module.exports = __webpack_public_path__ + "static/media/videos.1c42610b.png";